'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: 15px 20px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n  ', ';\n'], ['\n  width: 100%;\n  padding: 15px 20px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          height: 100%;\n          flex: 1;\n          overflow: scroll;\n        '], ['\n          height: 100%;\n          flex: 1;\n          overflow: scroll;\n        ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Grid = _styledComponents2.default.div(_templateObject, function (_ref) {
  var fullscreen = _ref.fullscreen;
  return fullscreen ? '' : (0, _styledComponents.css)(_templateObject2);
});

exports.default = Grid;